import { PcbLayoutFootprintPadShape, PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { geom2, mat3 } from "../../../common";
import { createPolygonShape } from "../../../fills/FillHelpers";
import { getConnectedCopperLayers } from "../../layout_engine/helpers/getConnectedCopperLayers";
function getPolygonOutlineShape(node) {
    const transform = node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity();
    const transformInverse = mat3.invert(transform);
    if (node.bakedRules.polygonShape === PcbLayoutFootprintPadShape.circular) {
        const isSquare = node.bakedRules.size.x === node.bakedRules.size.y;
        if (isSquare) {
            return {
                type: PrimitiveType.Circle,
                radius: node.bakedRules.size.x / 2,
                transform,
                transformInverse,
            };
        }
        else {
            return {
                type: PrimitiveType.Oblong,
                width: node.bakedRules.size.x,
                height: node.bakedRules.size.y,
                transform,
                transformInverse,
            };
        }
    }
    if (node.bakedRules.polygonShape === PcbLayoutFootprintPadShape.rectangle) {
        const hasCornerRadius = node.bakedRules.cornerRadius &&
            (node.bakedRules.cornerRadius.topLeft > 0 ||
                node.bakedRules.cornerRadius.bottomLeft > 0 ||
                node.bakedRules.cornerRadius.topRight > 0 ||
                node.bakedRules.cornerRadius.bottomRight > 0);
        if (hasCornerRadius && node.bakedRules.cornerRadius) {
            return {
                type: PrimitiveType.RoundedRectangle,
                width: node.bakedRules.size.x,
                height: node.bakedRules.size.y,
                radiusTopLeft: node.bakedRules.cornerRadius.topLeft,
                radiusBottomLeft: node.bakedRules.cornerRadius.bottomLeft,
                radiusTopRight: node.bakedRules.cornerRadius.topRight,
                radiusBottomRight: node.bakedRules.cornerRadius.bottomRight,
                transform,
                transformInverse,
            };
        }
        else {
            return {
                type: PrimitiveType.Rectangle,
                width: node.bakedRules.size.x,
                height: node.bakedRules.size.y,
                transform,
                transformInverse,
            };
        }
    }
    const polygonShape = createPolygonShape(node);
    if (!polygonShape) {
        return null;
    }
    const points = polygonShape.getPoints();
    return {
        type: PrimitiveType.ApproxPolygon,
        points,
        transform,
        transformInverse,
        convex: geom2.isConvexFromPoints(points),
    };
}
export function createPrimitivesForPolygon(node, stackup) {
    const primitives = [];
    const connectedLayers = getConnectedCopperLayers(node, stackup);
    if (!connectedLayers || connectedLayers.length === 0) {
        return primitives;
    }
    const outlineShape = getPolygonOutlineShape(node);
    if (outlineShape) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        connectedLayers.forEach((layer) => {
            primitives.push({
                ...outlineShape,
                role: PrimitiveRole.polygonOutline,
                layerId: layer.uid,
            });
        });
    }
    // TODO: Add copper primitives from fill shapes
    return primitives;
}
//# sourceMappingURL=createPrimitivesForPolygon.js.map